import { Controller, useFormContext } from 'react-hook-form'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import DocumentNumber from 'modules/expenses/components/expenses/Form/DocumentNumber'

const FIELD_NAME = 'documentNumber'

const DocumentNumberField = ({
  isFieldMandatory,
  isFieldReadOnly,
}: WithCustomizationFieldsProps & WithFieldPermissionsProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <DocumentNumber
          value={field.value ?? ''}
          onChange={(value) => {
            field.onChange(value)
          }}
          mandatory={isFieldMandatory ?? false}
          error={castError(errors?.documentNumber)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(DocumentNumberField, FIELD_NAME))
